<template>
	<o-section title="Modifiez le nom de votre organisation">
		<o-input
			v-model="setup.organizationName"
			label="Nom de l'organisation"
			:donetyping="600"
			:validation="setup.isValid"
			autofocus
			@input="setup.generateAndVerifyMailAsync($event)"
			@submit="setup.saveAsync()"/>
		<o-input
			v-model="setup.organizationEmail"
			disabled
			type="mail"
			label="e-mail de l'organisation"/>

		<o-alert
			v-if="setup.feedback.message"
			color="warning">
			{{ setup.feedback.message }}
		</o-alert>
	</o-section>

	<o-section
		align="stretch"
		gap="sm">
		<o-button
			color="danger"
			outline
			@click="_modal?.close()">
			Annuler
		</o-button>
		<o-button
			color="brand"
			:disabled="!setup.isValid"
			:outline="!setup.isValid"
			@click="setup.saveAsync()">
			Sauvegarder
		</o-button>
	</o-section>
</template>

<script setup lang="ts">
import OrganizationModalNameUpdateSetupService from '@/setup/organization/OrganizationModalNameUpdateSetupService';
import { inject } from 'vue';
const _modal = inject<OrionModal>('_modal');
const props = defineProps(OrganizationModalNameUpdateSetupService.props);
const setup = new OrganizationModalNameUpdateSetupService(props, _modal);
</script>
